
















import Vue from "vue"
import {CsvImportResponse, CsvImportResponseEntity, CsvStatus} from "@/model/dto/csv-upload.ts"
import {FieldDescriptor, FieldTypeEnum} from "@/model/entity/field-descriptor"
import {DatatableEntity} from "@/model/entity/datatable-entity"
import {Language} from "@/model/entity/language/language"
import {plainToClass} from "class-transformer"
import Upload, {IUpload} from "@/components/upload/Upload.vue"
import {languageService} from "@/model/service/language/language-service"

class LanguageCsvDto extends DatatableEntity implements CsvImportResponseEntity {
  @FieldDescriptor({fieldType: FieldTypeEnum.TEXT, fieldPrettyName: "entity.language.key", columnWidth: "100"})
  key: string

  @FieldDescriptor({fieldType: FieldTypeEnum.TEXT, fieldPrettyName: "entity.language.lang", columnWidth: "100"})
  lang: string

  @FieldDescriptor({fieldType: FieldTypeEnum.TEXT, fieldPrettyName: "entity.language.value", columnWidth: "100"})
  value: string

  csvStatus: CsvStatus

  statusDescription: string

  constructor(key: string, lang: string, value: string, csvStatus: CsvStatus, statusDescription: string) {
    super()
    this.key = key
    this.lang = lang
    this.value = value
    this.csvStatus = csvStatus
    this.statusDescription = statusDescription
  }
}

export default Vue.extend({
  components: {Upload},
  data() {
    return {
      fields: LanguageCsvDto.getFieldDescriptionList(),
      languageService: languageService
    }
  },
  methods: {
    back() {
      this.$router.push("/language_editor")
    },
    submit(fileResponseList: CsvImportResponse<LanguageCsvDto>[]) {
      const vm = this

      const csvFile = fileResponseList
        .flatMap(fileResponse => {
          return fileResponse.items
        })
        .map(
          languageCsvDto =>
            new Language(
              undefined,
              languageCsvDto.key.replace(/['"]+/g, ""),
              languageCsvDto.lang.replace(/['"]+/g, ""),
              languageCsvDto.value.replace(/['"]+/g, "")
            )
        )

      vm.$http
        .post("/language/submit_csv", csvFile as any)
        .then(() => {
          vm.$http.get("/language/get_languages").then(re => {
            vm.$i18n.setLocaleMessage("en", re.data.en)
            vm.$i18n.setLocaleMessage("hr", re.data.hr)
            vm.$i18n.setLocaleMessage("si", re.data.si)
            vm.endLoad()
            vm.$router.push("/language_editor")
          })
        })
        .catch(error => {
          vm.endLoad()
          vm.$notify.error({
            title: vm.$t("upload.status.error").toString(),
            message: error.message
          })
        })
    },
    uploadFile(fileData: FormData) {
      const vm = this

      const upload = vm.$refs.upload as IUpload
      vm.startLoad()
      this.$http
        .post("language/file_upload", fileData)
        .then(response => {
          response.data.forEach(
            (file: any) => (file.items = file.items.map((raw: object) => plainToClass(Language, raw)))
          )
          upload.fileResponseList.push(...response.data)
          vm.endLoad()
        })
        .catch(() => {
          vm.endLoad()
        })
    }
  }
})
